// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__c7QB8","primary":"Button_primary__qLPM7","outline":"Button_outline__JoUTd","fullWidth":"Button_fullWidth__Wu5r6"};